var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOdooIcon = function SvgOdooIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.05 49.9c0-27.14 21.82-48.85 49.07-48.85 27 .01 49.05 22.04 48.82 49.16-.22 27.33-22.06 48.99-49.52 48.73C21.9 98.68.82 76.18 1.05 49.9zm77.79.24c-.03-16.45-13.05-29.36-29.55-29.39-14.91-.02-29.32 11.77-29.27 29.5.06 16.89 13.17 29.51 29.65 29.41 17.72-.09 29.62-14.82 29.17-29.52z"
  })));
};
export default SvgOdooIcon;